import { NavLink } from "react-router-dom"
import menuCommunityIcon from "../../assets/img/sidebar-audience-icon.svg"
import menuNewsletterIcon from "../../assets/img/sidebar-post-icon.svg"
import broadcastIcon from "../../assets/img/broadcast-icon.svg"
import menuProducts from "../../assets/img/menu-products.svg"
import menuOrders from "../../assets/img/menu-orders.svg"
import closedArrow from "../../assets/img/sidebar-close.svg"
import openedArrow from "../../assets/img/sidebar-open.svg"
import menuProfileSettings from "../../assets/img/menu-payout-settings.svg"
import notConnected from "../../assets/img/payout-settings-not-connected.svg";
import { useDispatch, useSelector } from "react-redux"
import { OverlayTrigger, Tooltip } from "react-bootstrap"
import usericon from "../../assets/img/products/usericon.svg"
import calendarSidebarIcon from "../../assets/img/products/calendarSidebarIcon.svg"
import StarIcon from "../../assets/img/star.svg"
import { useEffect, useState } from "react"
import { showLoader, hideLoader } from "../../components/loader";
import { apiUrl, appUrl } from "../../utils/url"
import chevronDown from "../../assets/img/chevron-down.svg";
import DashboardProjectsModal from "../dashboard/projects/modal"
import NewBottomBar from "./new-bottombar"
import { audiencePosts as apiService } from "../../services/postRequests/audience";
import staricon from "../../assets/img/star.svg"
import Skeleton from "react-loading-skeleton"
import { useHistory, useLocation } from "react-router-dom/cjs/react-router-dom"
import { useParams } from "react-router-dom/cjs/react-router-dom.min"
import { toast } from "react-toastify"
import Accounts from "../../pages/accounts"
import ConfirmationModal from "../confirmation-modal"
import payoutsicon from "../../assets/img/menu-payout-settings.svg"
import dotsIcon from "../../assets/img/dots.svg";
import tickIcon from "../../assets/img/blue-tick.svg";
import { Link } from "react-router-dom";
import { ChevronRight } from "../../utils/svg"
import { redirectToWalkthrough } from "../google-sign"
import analyticsIcon from "../../assets/img/line-chart.svg"
import NewUpdateModal from "../common/NewUpdateModal"

export function creditsUsageJSX(){
    const { basePath } = useSelector(state => state?.slugReducer);

    const creditsDataReducer = useSelector(state => state?.creditsDataReducer)
    return (
        <div className="credits-usage-section">
            <div className="d-flex justify-content-between align-items-center">
                <span className="credits">{creditsDataReducer?.total_credits} Credits Remaining</span>
                <span className={`${creditsDataReducer?.plan_type == 'basic' ? "project-types bg-f3f3f3 text-capitalize" : "sidebar-plantype"}`}>
                    {creditsDataReducer?.plan_type == 'basic' ? 'Free':
                    <>
                    <svg xmlns="http://www.w3.org/2000/svg" width="11" height="10" viewBox="0 0 11 10" fill="none">
                        <path d="M3.025 5.45L3.37801 6.15601C3.49748 6.39495 3.55721 6.51442 3.63701 6.61795C3.70783 6.70982 3.79018 6.79217 3.88205 6.86299C3.98558 6.94279 4.10505 7.00252 4.34399 7.12199L5.05 7.475L4.34399 7.82801C4.10505 7.94748 3.98558 8.00721 3.88205 8.08701C3.79018 8.15783 3.70783 8.24018 3.63701 8.33205C3.55721 8.43558 3.49748 8.55505 3.37801 8.79399L3.025 9.5L2.67199 8.79399C2.55252 8.55505 2.49279 8.43558 2.41299 8.33205C2.34217 8.24018 2.25982 8.15783 2.16795 8.08701C2.06442 8.00721 1.94495 7.94748 1.70601 7.82801L1 7.475L1.70601 7.12199C1.94495 7.00252 2.06442 6.94279 2.16795 6.86299C2.25982 6.79217 2.34217 6.70982 2.41299 6.61795C2.49279 6.51442 2.55252 6.39495 2.67199 6.15601L3.025 5.45Z" stroke="#213B7C" stroke-linecap="round" stroke-linejoin="round" />
                        <path d="M6.85 0.5L7.38038 1.87899C7.50729 2.20894 7.57074 2.37392 7.66941 2.51269C7.75686 2.63568 7.86432 2.74314 7.98731 2.83059C8.12608 2.92926 8.29106 2.99271 8.62101 3.11962L10 3.65L8.62101 4.18038C8.29106 4.30729 8.12608 4.37074 7.98731 4.46941C7.86432 4.55686 7.75686 4.66432 7.66941 4.78731C7.57074 4.92608 7.50729 5.09106 7.38038 5.42101L6.85 6.8L6.31962 5.42101C6.19271 5.09106 6.12926 4.92608 6.03059 4.78731C5.94314 4.66432 5.83568 4.55686 5.71269 4.46941C5.57392 4.37074 5.40894 4.30729 5.07899 4.18038L3.7 3.65L5.07899 3.11962C5.40894 2.99271 5.57392 2.92926 5.71269 2.83059C5.83568 2.74314 5.94314 2.63568 6.03059 2.51269C6.12926 2.37392 6.19271 2.20894 6.31962 1.87899L6.85 0.5Z" stroke="#213B7C" stroke-linecap="round" stroke-linejoin="round" />
                    </svg>
                     {creditsDataReducer?.plan_type}
                     </>
                    }
                </span>
            </div>
            <div className="progress">
                <div className="progress-bar" role="progressbar" style={{ width: `${creditsDataReducer?.used_credits_percentage}%` }} aria-valuenow="50" aria-valuemin="0" aria-valuemax="100"></div>
            </div>
            <div className="reset-date">
                <span>
                    Resets to {creditsDataReducer?.credits_limit} in {creditsDataReducer?.days_until_reset} days
                </span>
                <span>
                    <svg xmlns="http://www.w3.org/2000/svg" width="2" height="3" viewBox="0 0 2 3" fill="none">
                        <circle cx="1" cy="1.5" r="1" fill="#5B5B5B" />
                    </svg>
                </span>
                <NavLink to={`${basePath}/settings`} className="blue-text">
                    Manage Plan
                    <svg xmlns="http://www.w3.org/2000/svg" width="8" height="7" viewBox="0 0 8 7" fill="none">
                        <path d="M1 6.5L7 0.5M7 0.5H3M7 0.5V4.5" stroke="#1188FF" stroke-linecap="round" stroke-linejoin="round" />
                    </svg>
                </NavLink>
            </div>
        </div>
    );
}
const NewSideBar = ({ from,newAcccountCreated,sharedProjects,setSharedProjects,selectedProject, setSelectedProject,newProjectcreated,sidebarOpen,setSideBarOpen,onMenuClick,activePage,renderCalendar,selectedSlug,setSelectedSlug ,setpayoutSettingsModal,basePath,setbasePath,selectedProfile,setSelectedProfile,isLoading, setisLoading, children , projects, setProjects, setStats,welcomeModalOpen}) => {
    const {pathname} = useLocation()
    const [isLoadingState, setisLoadingState] = useState(true)
    const [projectsState, setProjectsState] = useState([]);
    const [basePathState, setbasePathState] = useState(null)
    const [selectedProfileState, setSelectedProfileState] = useState(null)
    // console.log("pathname", pathname);
    const { slug } = useSelector(state => state?.slugReducer);
    const { stripeConnectReducer } = useSelector(state => state);
    const username = localStorage.user
    // const [statsState, setStatsState] = useState([])
    const router = useHistory()
    const [isProjectLoading, setisProjectLoading] = useState(true)
    const [showModal, setShowModal] = useState({ show: false, duplicate: false });
    const [title, setTitle] = useState(false);
    const [projectSlug, setProjectSlug] = useState(false);
    const [profile, setProfile] = useState(false);
    const [selectedSlugState, setSelectedSlugState] = useState(null)
    const dispatch = useDispatch();
    const [selectedProjectState, setSelectedProjectState] = useState(true)
    const [sharedProjectsState, setSharedProjectsState] = useState([]);
    const handleCloseModal = () => setShowModal({ show: false, duplicate: false })
    const handleOpenModal = () => setShowModal({ show: true, duplicate: false })
    const accountsModalOpen = useSelector(state => state.accountsModalReducer)
    const storedValue =  localStorage.sidebarOpen;
    // console.log("from",from)
    const [isOpen, setIsOpen] = useState(storedValue ? JSON.parse(storedValue) : false);
    const [confirmationModalShow, setconfirmationModalShow] = useState({ show: false, text: null });
    const creditsDataReducer = useSelector(state => state?.creditsDataReducer)
    const [openDropdown, setOpenDropdown] = useState(null);
    const toggleSidebar = () => {
      setIsOpen(!isOpen);
      localStorage.setItem("sidebarOpen",!isOpen);
    };
    useEffect(()=>{
        if (from == 'dashboard' && newAcccountCreated) {
            localStorage.setItem("sidebarOpen",true);
        }
    },[from])
        const getProjects = () => {
            showLoader();
            var myHeaders = new Headers();
            myHeaders.append("Authorization", `Bearer ${localStorage?.getItem("token")}`);

            fetch(apiUrl + "/project/get-all", { headers: myHeaders })
                .then(async (res) => {
                    const response = await res.json();
                    if (response?.status_code == 401 && response?.status_message == "unauthorized") {
                        router.push("/logout")
                    }
                    if(response?.data?.shared_projects.length == 0 && response?.data.projects.length == 0){
                        localStorage.setItem("currentStep", 1);
                        localStorage.setItem("lastStep", 0);
                        localStorage.setItem("walkthrough", 0);
                        redirectToWalkthrough(1, router)
                    }
                    // console.log("response", response)
                    // dispatch({ type: "SET_NEW_USER", payload: response?.data.projects[0]?.new_user == 1 ? true : false });
                    // dispatch({ type: "SET_PRO", payload: response?.data.projects[0]?.pro == 1 ? true : false });
                    localStorage.setItem("user", response?.data?.name);
                    localStorage.setItem("email", response?.data?.email);
                    setSharedProjectsState(response?.data?.shared_projects)
                    // setSelectedProjectState(true)
                    setisProjectLoading(false)
                    setProjectsState(response?.data.projects)
                    setisLoadingState(false)
                    dispatch({ type: 'SET_SHOW_NEW_UPDATE_POPUP', payload:response?.data?.show_update_popup ?? false})
                    if (window.location.pathname.includes("dashboard") == false && !window.location.pathname.includes('account-settings')) {
                        var currentSlug = window.location.pathname.split("/")[2];
                        const matchingProject = response?.data.projects.find(project => project.slug === currentSlug );
                        if (matchingProject) {       
                            setSelectedProjectState(true)             
                            setSelectedProfileState(matchingProject?.id)
                            setbasePathState("/project/" + matchingProject?.slug)
                            setSelectedSlugState(matchingProject?.slug)
                            localStorage.slug = matchingProject?.slug;
                        }
                        else{
                            const sharingProject = response?.data.shared_projects.find(sharedproject => sharedproject.project.slug === currentSlug )
                            if (sharingProject) {
                                setSelectedProjectState(false)
                                setSelectedProfileState(sharingProject?.project?.id)
                                setbasePathState("/project/" + sharingProject?.project?.slug)
                        //         setisLoadingState(false)
                        //         setSelectedSlugState(sharingProject?.project?.slug)
                        //         localStorage.slug = sharingProject?.project?.slug;
                            }
                            // else{
                        //         toast.error("Project Not found");
                        //         return window.location.href = "https://www.zaap.ai/";
                        //     }
                            // if (!window.location.pathname.includes('account')) {                                
                            // }
                            // setSelectedProfileState(response?.data.projects[0]?.id)
                            // setbasePathState("/project/" + response?.data.projects[0]?.slug)
                            // setSelectedSlugState(response?.data.projects[0]?.slug)
                            // setisLoadingState(false)
                        }
                    }
                    // else{
                        
                    // }
                    // if (from == 'dashboard') {
                    //     var currentSlug = localStorage?.slug;
                    //     const matchingProject = response?.data.projects.find(project => project.slug === currentSlug);
                    //     setSelectedProfileState(matchingProject?.id)
                    //     if (matchingProject) {
                    //     dispatch({ type: "SET_NEW_USER", payload: matchingProject?.new_user == 1 ? true : false });
                    //     dispatch({ type: "SET_PRO", payload: matchingProject?.pro == 1 ? true : false });
                    //     setbasePathState("/project/" + matchingProject?.slug)
                    //     setSelectedSlugState(matchingProject?.slug)
                    //     setisLoadingState(false)
                    //     localStorage.slug = matchingProject?.slug;
                    //     setSelectedSlug(matchingProject?.slug)
                    //     setisLoading(false)
                    //     setProjects(response?.data.projects)
                    //     setbasePath("/project/" + matchingProject?.slug)
                    //     setSelectedProfile(matchingProject?.id)
                    //     setSharedProjects(response?.data?.shared_projects)
                    //     setSelectedProject(true)
                    //     setSelectedProjectState(true)
                    //     // }else{
                    //     //     const sharedProject = response?.data.shared_projects.find(project => project.project.slug === currentSlug);
                    //     //     if (sharedProject) {
                    //     //         localStorage.slug = sharedProject?.project?.slug;
                    //     //         setisLoadingState(false)
                    //     //         setisLoading(false)
                    //     //         setSelectedProject(false)
                    //     //         setSelectedProjectState(false)
                    //     //         setbasePathState("/project/" + sharedProject?.project?.slug)
                    //     //         setSharedProjects(response?.data?.shared_projects)
                    //     //         setSharedProjectsState(response?.data?.shared_projects)
                    //     //         setSelectedProfileState(sharedProject?.project?.id)
                    //     //     }
                    //     }
                    // } 
                    hideLoader()
                }).catch((err) => {
                    console.log(err)
                    setisProjectLoading(false)
                    hideLoader()
                })

            hideLoader()
        }
        const connectionWarning = () => {
            if (stripeConnectReducer?.paypal === 0 && stripeConnectReducer?.stripe === 0)
                return (
                    <OverlayTrigger
                        placement="top"
                        overlay={<Tooltip id="button-tooltip-2">Connect Stripe / Paypal to start selling</Tooltip>}
                    ><img src={notConnected} width="20px" alt="" className="payout-warning ms-2" />
                    </OverlayTrigger>)
        }
        const handleClick = (page) => {
            onMenuClick(page);
        };
        useEffect(() => {
            if (selectedProjectState) {
            projectsState?.filter((val) => val?.id == selectedProfileState).map((value, index) => (
                setProfile(value?.settings[1]?.value),
                setTitle(value?.settings[0]?.value),
                setProjectSlug(value?.slug)
            ))
            }else {
                sharedProjectsState?.filter((val) => val?.project?.id == selectedProfileState).map((value, index) => (
                    setProfile(value?.project?.settings[1]?.value),
                    setTitle(value?.project?.settings[0]?.value),
                    setProjectSlug(value?.project?.slug)
                ))
            }
        }, [sharedProjectsState]);

        const changeProject = (e, id, slug,picture,name) => {
            e && e.preventDefault();
            localStorage.slug = slug;
            setTitle(name);
            setProfile(picture)
            setProjectSlug(slug)
            if (from == "dashboard") {
                setSelectedProfile(id)
                setbasePath("/project/" + slug)
                setSelectedSlug(slug)
                
                // getStats(e, id, slug)
                renderCalendar();
            }
            setSelectedProfileState(id)
            setbasePathState("/project/" + slug)
            setSelectedSlugState(slug)
            if(!window.location.pathname.includes("/dashboard")) {
                var currentPathName = window.location.pathname.split("/")[3]
                // window.location.href = "/project/" + slug + "/"+currentPathName;
                router.replace("/project/" + slug + "/"+currentPathName)
            }
        }
        // const getStats = (e, id, slug,getdashboard=false) => {
        //     e && e.preventDefault();
        //     const api = apiUrl + "/project/get-dashboard/" + slug;
        //     var myHeaders = new Headers();
        //     myHeaders.append("Authorization", `Bearer ${localStorage?.getItem("token")}`);
        //     const setOptions = {
        //         method: "GET",
        //         headers: myHeaders,
        //     }
        //     apiService(api, hideLoader, setOptions)?.then((response) => {
        //         if (response) {
        //             console.log("respo",response)
        //             setStats(response);
        //             if (getdashboard) {
        //                 setSelectedProfile(response?.project?.id)
        //                 setbasePath("/project/" + slug)
        //             }
        //         }
        //     })
        // }
        // useEffect(() => {
        //     if (window.location.pathname.includes("/dashboard")) {
        //         if (selectedSlug) {
        //             let getdashboard = true;
        //             getStats(null, null, localStorage?.slug,getdashboard)
        //         }
        //     }
        // },[selectedSlug])
        const deleteProject = (id) => {
            showLoader()
            const api = apiUrl + "/project/delete/" + id
            var myHeaders = new Headers();
            myHeaders.append("Authorization", `Bearer ${localStorage?.getItem("token")}`);
            const setOptions = {
                method: "DELETE",
                headers: myHeaders,
            }
            apiService(api, hideLoader, setOptions)?.then((response) => {
                if (response) {
                    setconfirmationModalShow({ show: false, text: null })
                    // console.log("deleteresponse",response)
                    // getProjects()
                    const updatedProjectsState = projectsState.filter(project => project?.slug !== id);
                    // console.log("updatedProjectsState",updatedProjectsState,"id",id)
                    // Update projectsState with the filtered array
                    setProjectsState(updatedProjectsState);
                    if (slug == id) {
                        if (response?.project_counts > 1) {
                            // changeProject(projectsState[1]?.id, projectsState[1]?.slug,projectsState[1]?.settings[1]?.value,projectsState[1]?.settings[1]?.value)
                            window.location.href = appUrl + '/project/' + updatedProjectsState[1]?.slug + "/campaigns";
                        }else if(response?.project_counts == 1){
                            // changeProject(projectsState[0]?.id, projectsState[0]?.slug,projectsState[0]?.settings[1]?.value,projectsState[0]?.settings[0]?.value)
                            window.location.href = appUrl + '/project/' + updatedProjectsState[0]?.slug + "/campaigns";
                        }else{
                            window.location.href = "/login";
                        }
                    }else {
                        setconfirmationModalShow({ show: false, text: null, id: null, deleteAll: null })
                    }
                    // if (response?.project_counts == 0) {
                    // }
                }
                else {
                    hideLoader()
                }
            }).catch(() => hideLoader())
        }
        useEffect(() => {
            document.addEventListener('DOMContentLoaded', function() {
                var headerDropdown = document.querySelector('#project-dropdown');
                headerDropdown.onclick = () => headerDropdown.classList.toggle('active');
            });
        });
        const openAccountsModal = (e) => {
            e.preventDefault();
            dispatch({ type: "SET_ACCOUNTS_MODAL", payload: true })
        } 
        function checkScreenSize() {
            if (window.innerWidth < 1429 && window.innerWidth > 729) {
                setIsOpen(false);
            }else{
                setIsOpen(true);
            }
          }
        // useEffect(()=>{
        //         window.addEventListener('resize', checkScreenSize);
                
        //         window.addEventListener('load', checkScreenSize);    
        // },[])

        
    useEffect(() => {
            if (projectsState?.length == 0 && (!welcomeModalOpen)){
            // console.log("projectsState",projectsState)
                getProjects()}
            else localStorage.removeItem("sendRequest")
        }, []);

        function checkSidebarWidth() {
            const sidebar = document?.querySelector('.left-side-bar');
            const creditsUsageSection = document?.querySelector('.credits-usage-section');
            if (creditsUsageSection) {
                const sidebarWidth = sidebar?.offsetWidth;
                if (sidebarWidth >= 260 ) {
                        creditsUsageSection.style.opacity = '1';
                } else {
                    creditsUsageSection.style.opacity = '0';
                }
            }
        }
        useEffect(()=>{
            if (from != 'settings' && from != 'account' && from !== "settingsMobile" && from !== 'accountMobile') {
                if (isOpen) {
                    setTimeout(() => {
                        checkSidebarWidth()
                    }, 598);
                }else{
                    const creditsUsageSection = document?.querySelector('.credits-usage-section');
                    if (creditsUsageSection) {
                        creditsUsageSection.style.opacity = '0';
                    }
                }
            }
        },[isOpen])
        const handleDropdownClick = (e,index) => {
            e.stopPropagation();
            if (openDropdown === index) {
                setOpenDropdown(null);
            } else {
                setOpenDropdown(index);
            }
        };
    return (
    <>
        <div className={`left-side-bar d-flex align-items-center flex-column justify-content-between ${from == "settingsMobile" || from == 'accountMobile' ? "settings-sidebar-for-mobile " + (sidebarOpen ? 'open' : 'closed') : ""}${from !== "settingsMobile" && from !== 'accountMobile'? (isOpen ? 'open' : 'closed') : ""}`} onClick={() => setOpenDropdown(null)}>
            <div className="toggle-button" onClick={toggleSidebar}>
                <img src={isOpen ? closedArrow : openedArrow} alt="" width={11} height={8}/>
            </div>
            {from == "settings" || from == "account" || from == "settingsMobile" || from == 'accountMobile' ? 
                <div className="side-bar-menus w-100 h-100">
                    {/* {from == 'settings' || from == "settingsMobile" ? */}
                    {/* <> */}
                    <div className=" side-bar-headings mb-2">Workspace Settings</div>
                    <a  className={`left-menu-item ${activePage == "upgrade" ? 'active':''}`} onClick={() => handleClick('upgrade')}>
                        <span ><img src={staricon} alt="" /></span>
                        <p className="mb-0 ms-2">Plan</p>
                    </a>
                    {/* <a  className={`left-menu-item ${activePage == "domains" ? 'active':''}`} onClick={() => handleClick('domains')}>
                    <span ><svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22" fill="none">
                        <path d="M8 3V1M14 19V21M3 8H1M19 14H21M3.91421 3.91421L2.5 2.5M18.0858 18.0858L19.5 19.5M11 16.6569L8.87868 18.7782C7.31658 20.3403 4.78392 20.3403 3.22183 18.7782C1.65973 17.2161 1.65973 14.6834 3.22183 13.1213L5.34315 11M16.6569 11L18.7782 8.87868C20.3403 7.31658 20.3403 4.78392 18.7782 3.22183C17.2161 1.65973 14.6834 1.65973 13.1213 3.22183L11 5.34315" stroke="#333333" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg></span>
                        <p className="mb-0 ms-2">Domain</p>
                    </a> */}
                    <a  className={`left-menu-item ${activePage == "team" ? 'active':''}`} onClick={() => handleClick('team')}>
                        <span >
                            <svg width="22" height="20" viewBox="0 0 22 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M16.9461 13.8369C18.402 14.5683 19.6503 15.742 20.5614 17.2096C20.7418 17.5003 20.832 17.6456 20.8632 17.8468C20.9266 18.2558 20.6469 18.7585 20.2661 18.9204C20.0786 19 19.8678 19 19.4461 19M14.9461 9.53224C16.4278 8.79589 17.4461 7.26686 17.4461 5.5C17.4461 3.73314 16.4278 2.20411 14.9461 1.46776M12.9461 5.5C12.9461 7.98528 10.9314 10 8.44613 10C5.96084 10 3.94613 7.98528 3.94613 5.5C3.94613 3.01472 5.96084 1 8.44613 1C10.9314 1 12.9461 3.01472 12.9461 5.5ZM1.50536 16.9383C3.09966 14.5446 5.6155 13 8.44613 13C11.2768 13 13.7926 14.5446 15.3869 16.9383C15.7362 17.4628 15.9108 17.725 15.8907 18.0599C15.875 18.3207 15.7041 18.64 15.4957 18.7976C15.228 19 14.86 19 14.1238 19H2.76848C2.0323 19 1.6642 19 1.39656 18.7976C1.18817 18.64 1.01721 18.3207 1.00156 18.0599C0.981454 17.725 1.15609 17.4628 1.50536 16.9383Z" stroke="#333333" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>
                        </span>
                        <p className="mb-0 ms-2">Team</p>
                    </a>
                    <a  className={`left-menu-item ${activePage == "branding" || activePage == "editBranding" ? 'active':''}`} onClick={() => handleClick('branding')}>
                    <span ><svg xmlns="http://www.w3.org/2000/svg" width="22" height="20" viewBox="0 0 16 16" fill="none">
                            <path d="M5.98837 7.3073L8.68052 9.99424M5.25784 14.2439C4.28379 15.216 2.42525 14.973 1 14.973C1.73051 13.5505 0.756471 11.6955 1.73051 10.7234C2.70456 9.7512 4.28379 9.7512 5.25784 10.7234C6.23188 11.6955 6.23188 13.2717 5.25784 14.2439ZM8.0704 10.6519L14.5817 3.63321C15.1553 3.01501 15.1368 2.05498 14.5399 1.45924C13.943 0.863502 12.9811 0.845046 12.3617 1.41745L5.32945 7.91621C4.96605 8.25204 4.78436 8.41995 4.67839 8.59903C4.42427 9.02846 4.41405 9.55935 4.65144 9.9982C4.75043 10.1812 4.92553 10.356 5.27572 10.7055C5.62592 11.055 5.80101 11.2298 5.98438 11.3286C6.42409 11.5655 6.956 11.5553 7.38626 11.3017C7.56569 11.1959 7.73392 11.0146 8.0704 10.6519Z" stroke="#333333" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg></span>
                        <p className="mb-0 ms-2">Branding</p>
                    </a>
                    {/* <a  className={`left-menu-item ${activePage == "payouts" ? 'active':''}`} onClick={() => handleClick('payouts')}>
                        <img src={payoutsicon} alt="" />
                        <p className="mb-0 ms-2">Payouts</p>
                    </a> */}
                    <a  className={`left-menu-item ${activePage == "integrations" ? 'active':''}`} onClick={() => handleClick('integrations')}>
                    <span ><svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22" fill="none">
                        <path d="M6.5 3.5C6.5 2.11929 7.61929 1 9 1C10.3807 1 11.5 2.11929 11.5 3.5V5H12.5C13.8978 5 14.5967 5 15.1481 5.22836C15.8831 5.53284 16.4672 6.11687 16.7716 6.85195C17 7.40326 17 8.10218 17 9.5H18.5C19.8807 9.5 21 10.6193 21 12C21 13.3807 19.8807 14.5 18.5 14.5H17V16.2C17 17.8802 17 18.7202 16.673 19.362C16.3854 19.9265 15.9265 20.3854 15.362 20.673C14.7202 21 13.8802 21 12.2 21H11.5V19.25C11.5 18.0074 10.4926 17 9.25 17C8.00736 17 7 18.0074 7 19.25V21H5.8C4.11984 21 3.27976 21 2.63803 20.673C2.07354 20.3854 1.6146 19.9265 1.32698 19.362C1 18.7202 1 17.8802 1 16.2V14.5H2.5C3.88071 14.5 5 13.3807 5 12C5 10.6193 3.88071 9.5 2.5 9.5H1C1 8.10218 1 7.40326 1.22836 6.85195C1.53284 6.11687 2.11687 5.53284 2.85195 5.22836C3.40326 5 4.10218 5 5.5 5H6.5V3.5Z" stroke="#333333" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg></span>
                        <p className="mb-0 ms-2">Integrations</p>
                    </a> 
                    {/* </> */}
                    {/* } */}
                    {/* {from == "account" || from == "accountMobile" ? */}
                    {/* <> */}
                    <div className=" side-bar-headings my-2">Account Settings</div>
                    <a  className={`left-menu-item ${activePage == "profile" ? 'active':''}`} onClick={() => handleClick('profile')}>
                        <img src={usericon} alt="" />
                        <p className="mb-0 ms-2">Profile</p>
                    </a>
                    <a  className={`left-menu-item ${activePage == "billing" ? 'active':''}`}  onClick={() => handleClick('billing')}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="22" height="18" viewBox="0 0 22 18" fill="none">
                        <path d="M5 8V12M17 6V10M16 1C18.4487 1 19.7731 1.37476 20.4321 1.66544C20.5199 1.70415 20.5638 1.72351 20.6904 1.84437C20.7663 1.91682 20.9049 2.12939 20.9405 2.22809C21 2.39274 21 2.48274 21 2.66274V13.4111C21 14.3199 21 14.7743 20.8637 15.0079C20.7251 15.2454 20.5914 15.3559 20.3319 15.4472C20.0769 15.5369 19.562 15.438 18.5322 15.2401C17.8114 15.1017 16.9565 15 16 15C13 15 10 17 6 17C3.55129 17 2.22687 16.6252 1.56788 16.3346C1.48012 16.2958 1.43624 16.2765 1.3096 16.1556C1.23369 16.0832 1.09512 15.8706 1.05947 15.7719C1 15.6073 1 15.5173 1 15.3373L1 4.58885C1 3.68009 1 3.2257 1.13628 2.99214C1.2749 2.75456 1.40859 2.64412 1.66806 2.55281C1.92314 2.46305 2.43803 2.56198 3.46783 2.75985C4.18862 2.89834 5.04348 3 6 3C9 3 12 1 16 1ZM13.5 9C13.5 10.3807 12.3807 11.5 11 11.5C9.61929 11.5 8.5 10.3807 8.5 9C8.5 7.61929 9.61929 6.5 11 6.5C12.3807 6.5 13.5 7.61929 13.5 9Z" stroke="#333333" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                        <p className="mb-0 ms-2">Billing</p>
                    </a>
                    <a  className={`left-menu-item ${activePage == "password" ? 'active':''}`}  onClick={() => handleClick('password')}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                        <path d="M15 6.99994C15 6.48812 14.8047 5.9763 14.4142 5.58579C14.0237 5.19526 13.5118 5 13 5M13 13C16.3137 13 19 10.3137 19 7C19 3.68629 16.3137 1 13 1C9.68629 1 7 3.68629 7 7C7 7.27368 7.01832 7.54308 7.05381 7.80704C7.11218 8.24118 7.14136 8.45825 7.12172 8.59559C7.10125 8.73865 7.0752 8.81575 7.00469 8.9419C6.937 9.063 6.81771 9.18229 6.57913 9.42087L1.46863 14.5314C1.29568 14.7043 1.2092 14.7908 1.14736 14.8917C1.09253 14.9812 1.05213 15.0787 1.02763 15.1808C1 15.2959 1 15.4182 1 15.6627V17.4C1 17.9601 1 18.2401 1.10899 18.454C1.20487 18.6422 1.35785 18.7951 1.54601 18.891C1.75992 19 2.03995 19 2.6 19H5V17H7V15H9L10.5791 13.4209C10.8177 13.1823 10.937 13.063 11.0581 12.9953C11.1843 12.9248 11.2613 12.8987 11.4044 12.8783C11.5417 12.8586 11.7588 12.8878 12.193 12.9462C12.4569 12.9817 12.7263 13 13 13Z" stroke="#333333" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                        <p class="mb-0 ms-2">Password</p>
                    </a>

                    <a  className={`left-menu-item ${activePage == "delete" ? 'active':''}`} onClick={() => handleClick('delete')}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                        <path d="M10 6V10M10 14H10.01M5.8 19H14.2C15.8802 19 16.7202 19 17.362 18.673C17.9265 18.3854 18.3854 17.9265 18.673 17.362C19 16.7202 19 15.8802 19 14.2V5.8C19 4.11984 19 3.27976 18.673 2.63803C18.3854 2.07354 17.9265 1.6146 17.362 1.32698C16.7202 1 15.8802 1 14.2 1H5.8C4.11984 1 3.27976 1 2.63803 1.32698C2.07354 1.6146 1.6146 2.07354 1.32698 2.63803C1 3.27976 1 4.11984 1 5.8V14.2C1 15.8802 1 16.7202 1.32698 17.362C1.6146 17.9265 2.07354 18.3854 2.63803 18.673C3.27976 19 4.11984 19 5.8 19Z" stroke="#333333" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                        <p className="mb-0 ms-2">Delete Account</p>
                    </a>
                    {/* </> */}
                    {/* } */}
                </div>:
            <div className="side-bar-menus w-100 h-100">
                {isLoadingState ? 
                <>
                    <div className="ms-u side-bar-headings">Manage</div>
                    <span className="sidebar-skeleton-wrapper">
                        <Skeleton className="left-menu-item"/> 
                    </span>
                    <span className="sidebar-skeleton-wrapper">
                        <Skeleton className="left-menu-item"/> 
                    </span>
                    <span className="sidebar-skeleton-wrapper">
                        <Skeleton className="left-menu-item"/> 
                    </span>
                </>
                :
                <>
                <div className="ms-u side-bar-headings">Manage</div>

                <NavLink to={`${basePathState}/campaigns`} activeClassName="active" className="left-menu-item" exact
                    isActive={(match, location) => {
                        return match || location.pathname === `${basePathState}/createCampaigns`;
                    }} >
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                        <path d="M8 14C10.6787 11.8171 10.7261 16.2383 14 12.6667M2.04411 12.2101C2.05031 11.9587 2.05341 11.8331 2.08379 11.7151C2.11072 11.6104 2.15338 11.5105 2.21029 11.4188C2.27447 11.3153 2.36296 11.2264 2.53993 11.0487L11.2417 2.30865C11.5908 1.95805 12.136 1.89931 12.5511 2.16754C13.0433 2.48553 13.4638 2.9034 13.7857 3.39431L13.8082 3.42871C13.8245 3.45358 13.8327 3.46601 13.8396 3.47721C14.0951 3.88885 14.0411 4.42196 13.7081 4.77337C13.6991 4.78293 13.6886 4.79345 13.6676 4.81451L5.01874 13.5014C4.83516 13.6858 4.74337 13.7779 4.63623 13.8439C4.54125 13.9023 4.43769 13.9452 4.32937 13.9712C4.20719 14.0005 4.07739 14.0003 3.81777 13.9999L2 13.997L2.04411 12.2101Z" stroke="#333333" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                    <p class="mb-0 ms-2">Campaigns</p>
                </NavLink>
                <NavLink to={`${basePathState}/leads`} activeClassName="active" className="left-menu-item">
                    <img src={menuCommunityIcon} width="16px" height="16px" alt="" />
                    <p className="mb-0 ms-2">Leads</p>
                </NavLink>                
                <NavLink to={`${basePathState}/analytics`} activeClassName="active" className="left-menu-item">
                    <img src={analyticsIcon} width="16px" height="16px" alt=""/>
                    <p className="mb-0 ms-2">Analytics</p>
                </NavLink> 
            </>
            }
            </div>
            }
            { from!= 'campaign_leads' && from != 'settings' && from != 'account' && from !== "settingsMobile" && from !== 'accountMobile'&&
            <>
            {creditsUsageJSX()}
            
            <div className="project-dropdown-main d-flex align-items-center flex-column w-100">
                    <div className="account-div project-dropdown d-flex align-items-center ps-1 dropdown-toggle noselect" id="project-dropdown" data-bs-toggle="dropdown" aria-expanded="false" >
                        <div>
                            {isLoadingState ?
                            <Skeleton
                                circle
                                height={45}
                                width={45}
                                containerClassName="avatar-skeleton"
                            />
                            :
                            <img src={profile} alt="" style={{maxWidth:"31px",marginLeft:"5px"}} />
                            }
                        </div>
                        <div className="account-div-title d-flex flex-column pt-1 ps-2 w-100">
                            <div className="account-div-title-main text-truncate">{isLoadingState ? (<Skeleton/>) : title }</div>
                            <div className="text-truncate" style={{color:"#8C8E9C",fontSize:"11px",marginTop:"-7px",maxWidth:"120px"}}>
                                <span>
                                    genpa.ge/{projectSlug}
                                </span>
                            </div>
                    </div>
                        <div style={{textAlign: "right"}}><img src={chevronDown} id="project-chevron-down" width="11px" alt="" className="ms-2 arrowact" /></div>
                    </div>
                    <ul className="project-dropdown-menu dropdown-menu " aria-labelledby="project-dropdown">
                        {projectsState?.map((value, index) => (
                            <li>
                            <div className="d-flex justify-content-between" style={localStorage.slug === value.slug ? { color: "#4397F7" ,background:"#F3F3F3",borderRadius:"10px"} : null}>
                            <div className="project-dropdown-item share-dropdown-item d-flex align-items-center ps-1 w-100" >
                                <div className="d-flex align-items-center w-100" onClick={(e) => { 
                                    // localStorage.slug = value.slug
                                changeProject(e, value.id, value?.slug,value?.settings[1]?.value,value?.settings[0]?.value) 
                                from == "dashboard" && setSelectedProject(true) 
                                setSelectedProjectState(true);
                                }}>
                                <div className="d-flex justify-content-start"><img src={value?.settings[1]?.value} alt="" width="25" /></div>
                                <div className="d-flex ps-2 w-100">
                                    @{value?.slug}
                                </div>
                                </div>
                            <div onClick={(e) => { handleDropdownClick(e,index)}}  className=" project-small-action-button dropdown-toggle noselect d-md-flex d-none" id="project-small-dropdown" data-bs-toggle="dropdown" aria-expanded="false">
                                {/* {localStorage.slug == value.slug ?
                                    <img src={tickIcon} alt="" style={{padding: "10px 5px"}}/>
                                    : */}
                                    <img src={dotsIcon} alt="" style={{padding: "10px 5px"}}/>
                                {/* } */}
                            </div>
                            <ul className={`dropdown-menu ${openDropdown == index ? 'd-block' : 'd-none'}`} aria-labelledby="project-small-dropdown">
                            {/* <li>
                                <Link to={`/project/${value.slug}/settings`} className="dropdown-item">
                                    <span className="me-5">
                                        Project Settings
                                    </span>
                                    <ChevronRight />
                                </Link>
                            </li> */}
                            <li>
                                <Link to={`/project/${value.slug}/rename`} onClick={(e) => {
                                    e.preventDefault()
                                    setShowModal({ show: true, title:'Rename Workspace', endPoint:'rename', rename: true, slug: value.slug })
                                }} className="dropdown-item">
                                    <span className="me-5">
                                        Rename Workspace
                                    </span>
                                    <ChevronRight />
                                </Link>
                            </li>
                                <li>
                                    <Link to={`project/${value.slug}/duplicate`} onClick={(e) => {
                                        e.preventDefault()
                                        setShowModal({ show: true, duplicate: true, slug: value.slug })
                                    }} className="dropdown-item">
                                        <span className="me-5">
                                            Duplicate Workspace
                                        </span>
                                        <ChevronRight />
                                    </Link>
                                </li>
                                <li>
                                    <Link to={`delete-projects`} onClick={((e) => {
                                        e.preventDefault();
                                        setconfirmationModalShow({
                                            show: true, title: 'Delete Workspace', text: "Are you sure you want to delete this workspace? This action is irreversible and all information will be lost.", id: value?.slug, callBackTo: "delete",
                                        })
                                    }).bind()} data-value={value?.slug} className="dropdown-item theme-active semi-bold">
                                        <span className="me-5" data-value={value?.slug}>Delete Workspace</span>
                                    </Link>
                                </li>
                            </ul>
                            </div>
                            </div>
                            </li>
                        ))}
                        {sharedProjectsState?.length >= 1 &&
                        <>
                        <b>Shared Projects</b>
                        {sharedProjectsState.map((value, index) => (
                            <>
                            <li>
                            <div className="d-flex justify-content-between" style={localStorage.slug === value.project.slug ? { color: "#4397F7" ,background:"#F3F3F3",borderRadius:"10px"} : null}>
                            <div className="project-dropdown-item w-100 share-dropdown-item d-flex align-items-center ps-1" 
                                onClick={(e) => {
                                    // console.log("value",value)
                                    // localStorage.slug = value?.project?.slug
                                    changeProject(e, value?.id, value?.project?.slug,value?.project?.settings[1]?.value,value?.project?.settings[0]?.value)
                                    from == "dashboard" && setSelectedProject(false) 
                                    setSelectedProjectState(false);
                                }}>
                                <div className="d-flex justify-content-start"><img src={value?.project?.settings[1]?.value} alt="" width="25" /></div>
                                <div className="d-flex ps-2 w-100">
                                    @{value?.project?.slug}
                                </div>
                            </div>
                            </div>
                            </li>
                        </>
                        ))}
                        </>
                        }
                        <li>
                            <div className="project-dropdown-item dropdown-item d-flex align-items-center ps-1 " onClick={handleOpenModal}>
                                <div className="ms-2">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 13" fill="none">
                                        <path d="M6.64084 1.64085C6.64084 1.14885 6.242 0.75 5.75 0.75C5.258 0.75 4.85915 1.14884 4.85915 1.64085V11.3592C4.85915 11.8512 5.258 12.25 5.75 12.25C6.242 12.25 6.64084 11.8512 6.64084 11.3592V1.64085Z" fill="#333333"/>
                                        <path d="M0.890844 5.60916C0.398845 5.60916 0 6.008 0 6.5C0 6.992 0.398845 7.39085 0.890844 7.39085L10.6092 7.39085C11.1012 7.39085 11.5 6.992 11.5 6.5C11.5 6.008 11.1012 5.60915 10.6092 5.60915L0.890844 5.60916Z" fill="#333333"/>
                                    </svg>
                                </div>
                                <div className="add-new-project-btn d-flex flex-column ms-2">Create New Workspace</div>
                            </div>
                        </li>
                    </ul>
            </div>
            </>
            }
        </div>

        {from != 'settings' && from != 'account' && from !== "settingsMobile" && from !== 'accountMobile'&&
        <NewBottomBar profile={profile} title={title} isLoading={isLoadingState} basePathState={basePathState} setSelectedProfile={setSelectedProfileState} changeProject={changeProject} setSelectedProject={setSelectedProjectState}projects={projectsState} sharedProjects={sharedProjectsState} selectedSlug={selectedSlugState} handleOpenModal={handleOpenModal}/>
        }
        {confirmationModalShow?.show && <ConfirmationModal confirmationModalShow={confirmationModalShow} setShow={setconfirmationModalShow} callback={deleteProject} />}
        <DashboardProjectsModal showModal={showModal} handleCloseModal={handleCloseModal} getProjects={getProjects} />
        {/* {accountsModalOpen && <Accounts accountsModalOpen={accountsModalOpen} />} */}
        </>
    )

}
export default NewSideBar